// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1s0E_","header":"MergedInvoice_header__3ylFd"};